import type {ListUserManagementUsersSearchInput} from "./list-user-management-users.schema";
import {keepPreviousData, useQuery} from "@tanstack/react-query";
import {listUserManagementUsersQueryOptions} from "./list-user-management-users.query-options";

export function useListUserManagementUsers(input: ListUserManagementUsersSearchInput) {
  return useQuery({
    ...listUserManagementUsersQueryOptions(input),
    placeholderData: keepPreviousData,
  });
}
